(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter-sans-images"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ns-newsletter-signup-v2')) {
    customElements.define('ns-newsletter-signup-v2', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        clearTimeout(this.timer);
        if (this.controller) this.controller.abort();
        this.hidePopup();
        if (this.portal) {
          this.append(this.dialog);
          this.portal.remove();
          this.portal = null;
        }
      }

      initialize() {
        if (!this.isConnected) return;

        this.designMode = this.dataset.designMode === 'true' || Boolean(window.Shopify && window.Shopify.designMode);
        this.dialog = this.querySelector('.ns-newsletter__popup');
        this.feedback = this.querySelector('[data-newsletter-state]');
        this.dismissKey = 'newsletter_signup_popup_until';
        this.subscriberKey = 'newsletter_signup_subscribed';

        if (!this.designMode && this.feedback && this.feedback.dataset.newsletterState === 'success') {
          this.writeStorage(this.subscriberKey, '1');
        }

        if (!this.dialog) {
          if (!this.designMode && this.feedback) this.feedback.focus();
          return;
        }

        this.controller = new AbortController();
        const options = { signal: this.controller.signal };

        this.dialog.addEventListener('click', (event) => {
          if (event.target.closest('[data-newsletter-close]')) this.dismiss();
        }, options);

        document.addEventListener('click', (event) => {
          if (this.designMode || !this.isPopupOpen()) return;
          if (!this.dialog.contains(event.target)) this.dismiss();
        }, options);

        document.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape' || event.defaultPrevented || !this.isPopupOpen()) return;
          if (document.querySelector('dialog:modal')) return;
          event.preventDefault();
          this.dismiss();
        }, options);

        if (this.designMode) {
          document.addEventListener('shopify:section:select', (event) => {
            if (String(event.detail.sectionId) === this.dataset.sectionId) this.openPopup();
          }, options);
          document.addEventListener('shopify:section:load', (event) => {
            if (String(event.detail.sectionId) === this.dataset.sectionId) this.openPopup();
          }, options);
          this.openPopup();
          return;
        }

        if (this.feedback) {
          this.openPopup();
          return;
        }

        if (this.dataset.knownSubscriber === 'true' || this.readStorage(this.subscriberKey) === '1') return;
        if (Number(this.readStorage(this.dismissKey) || 0) > Date.now()) return;

        const delay = Math.max(0, Number(this.dataset.delay) || 0) * 1000;
        this.timer = setTimeout(() => this.openPopup(), delay);
      }

      isPopupOpen() {
        if (!this.dialog) return false;
        return Boolean(this.portal && !this.portal.hidden && !this.dialog.hidden);
      }

      openPopup() {
        if (!this.isConnected || this.isPopupOpen()) return;

        if (!this.designMode && !this.feedback) {
          if (this.dataset.knownSubscriber === 'true' || this.readStorage(this.subscriberKey) === '1') return;
          if (Number(this.readStorage(this.dismissKey) || 0) > Date.now()) return;
        }

        if (!this.designMode && document.querySelector('dialog[open]')) {
          this.timer = setTimeout(() => this.openPopup(), 1000);
          return;
        }

        this.previousFocus = document.activeElement;
        this.createPortal();
        this.portal.hidden = false;
        this.dialog.hidden = false;
        if (this.feedback) this.feedback.focus({ preventScroll: true });
      }

      createPortal() {
        if (this.portal) return;
        this.portal = document.createElement('div');
        this.portal.className = 'ns-newsletter ns-newsletter__portal';
        this.portal.hidden = true;
        this.portal.style.cssText = this.style.cssText;
        this.portal.style.fontFamily = getComputedStyle(this).fontFamily;
        this.portal.dataset.displayMode = 'popup';
        const overlay = document.createElement('div');
        overlay.className = 'ns-newsletter__overlay';
        overlay.setAttribute('aria-hidden', 'true');
        this.portal.append(overlay, this.dialog);
        document.body.append(this.portal);
      }

      hidePopup() {
        clearTimeout(this.timer);
        if (!this.isPopupOpen()) return;
        const restoreFocus = this.dialog.contains(document.activeElement);
        this.dialog.hidden = true;
        this.portal.hidden = true;
        if (restoreFocus && this.previousFocus && this.previousFocus.isConnected) {
          this.previousFocus.focus({ preventScroll: true });
        }
      }

      dismiss() {
        if (!this.designMode) {
          const days = Math.max(1, Number(this.dataset.dismissDays) || 1);
          this.writeStorage(this.dismissKey, String(Date.now() + days * 86400000));
        }
        this.hidePopup();
      }

      readStorage(key) {
        try {
          return localStorage.getItem(key);
        } catch {
          return null;
        }
      }

      writeStorage(key, value) {
        try {
          localStorage.setItem(key, value);
        } catch {}
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
